import { AtomicOption } from '@df/ui/atomic/atomic.interface';
import range from 'lodash-es/range';

/**
 * Margin options
 */
export function getMargin(prefix: string, config) {
    let margins = range(config.margin.min || 0, config.margin.max ? config.margin.max + 1 : 0);

    if (config.margin.custom && Array.isArray(config.margin.custom)) {
        margins = [...margins, ...config.margin.custom];
    }

    const margin: AtomicOption[] = [];
    margins
        .sort((a, b) => a - b)
        .forEach((i: number) => {
            margin.push({
                key: `m-${prefix}-${i}`,
                title: `${i}`
            });
        });

    return margin;
}
